// eslint-disable-next-line no-restricted-imports -- TODO: update to `next/navigation` before using this component in App Router
import { useRouter } from "next/router";
import { parse } from "qs";

const useParsedQueryString = () => {
  const { asPath } = useRouter();
  const [url, _hash] = asPath.split("#");
  const [_path, query] = url.split("?");

  return parse(query);
};

export default useParsedQueryString;
